import { fetchGet, fetchPost, fetchPatch } from "@/lib/services";

export async function getZoneEmployees(zoneCode: string, page?: number, search?: string, status?: string) {
  const params = new URLSearchParams();
  params.append('Zone_Code', zoneCode);
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (status) params.append('Status', status.trim());
  return await fetchGet(`/employees/?${params.toString()}`);
}

export async function createZoneEmployee(data: any) {
  return await fetchPost('/employees/', data);
}

export async function updateZoneEmployee(id: number, data: any) {
  return await fetchPatch(`/employees/?Id=${id}`, data);
}

export async function getZoneRegisteredProfiles(zoneCode: string, page?: number, search?: string, status?: string) {
  const params = new URLSearchParams();
  params.append('Zone_Code', zoneCode);
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (status) params.append('Status', status.trim());
  return await fetchGet(`/registeredprofiles/?${params.toString()}`);
}

export async function getZoneVerification(zoneCode: string, status?: boolean, page?: number) {
  const params = new URLSearchParams();
  params.append('Zone_Code', zoneCode);
  if (status !== undefined) params.append('Status', String(status));
  if (page && page > 1) params.append('page', String(page));
  return await fetchGet(`/verfication/?${params.toString()}`);
}

export async function getZoneBranches(zoneCode: string, page?: number, search?: string) {
  const params = new URLSearchParams();
  params.append('Zone_Code', zoneCode);
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  return await fetchGet(`/branches/?${params.toString()}`);
}

export async function getZoneSchools(zoneCode: string, page?: number, search?: string) {
  const params = new URLSearchParams();
  params.append('Zone_Code', zoneCode);
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  return await fetchGet(`/schools/?${params.toString()}`);
}

export async function getZonePickups(zoneCode: string, summary?: boolean, page?: number) {
  const params = new URLSearchParams();
  params.append('Zone_Code', zoneCode);
  if (summary) params.append('pickups', 'true');
  if (page && page > 1) params.append('page', String(page));
  return await fetchGet(`/Pickups/?${params.toString()}`);
}

export async function getZoneSubscriptionData(
  zoneCode: string,
  summary?: boolean,
  activePage = 1,
  inactivePage = 1,
  expiringPage = 1,
  expiredPage= 1,
  readyPage = 1
) {
  const params = new URLSearchParams();

  params.append("Zone_Code", zoneCode);

  if (summary) {
    params.append("subscriptiondata", "true");
  }

  params.append("page_size", "20");
  params.append("active_page", String(activePage));
  params.append("inactive_page", String(inactivePage));
  params.append("expiring_page", String(expiringPage));
  params.append("expired_page", String(expiredPage));
  params.append("ready_page", String(readyPage));

  return await fetchGet(`/subscriptiondata/?${params.toString()}`);
}

export async function getZoneMasterPrices(zoneCode: string, page?: number) {
  const params = new URLSearchParams();
  params.append('Zone_Code', zoneCode);
  if (page && page > 1) params.append('page', String(page));
  return await fetchGet(`/masterprices/?${params.toString()}`);
}

export async function getZoneSubscriptions(zoneCode: string, page?: number) {
  const params = new URLSearchParams();
  params.append('Zone_Code', zoneCode);
  if (page && page > 1) params.append('page', String(page));
  return await fetchGet(`/plans/?${params.toString()}`);
}

export async function getZoneMasterPricesHistory(zoneCode: string, page?: number) {
  const params = new URLSearchParams();
  params.append('Zone_Code', zoneCode);
  if (page && page > 1) params.append('page', String(page));
  return await fetchGet(`/masterpriceshistory/?${params.toString()}`);
}

export async function getZoneSubscriptionsHistory(zoneCode: string, page?: number) {
  const params = new URLSearchParams();
  params.append('Zone_Code', zoneCode);
  if (page && page > 1) params.append('page', String(page));
  return await fetchGet(`/SubscriptionPlanshistory/?${params.toString()}`);
}
